import * as HtmlParsing from "./HtmlParsing";
import {aiStore} from "../../index";
import {handleAbort} from "./PdfParser";

function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

function arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}

function detectImage(hexData) {
    try {
        if (hexData.length < 20 || hexData.length % 2 !== 0) {
            return null;
        }

        const bytes = new Uint8Array(hexData.length / 2);
        for (let i = 0; i < hexData.length; i += 2) {
            bytes[i / 2] = parseInt(hexData.substr(i, 2), 16);
        }
        const base64 = arrayBufferToBase64(bytes);

        if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47) {
            return { format: 'png', base64 };
        }
        if (bytes[0] === 0xFF && bytes[1] === 0xD8 && bytes[2] === 0xFF) {
            return { format: 'jpeg', base64 };
        }
        if (bytes[0] === 0x47 && bytes[1] === 0x49 && bytes[2] === 0x46) {
            return { format: 'gif', base64 };
        }
        if (bytes[0] === 0x42 && bytes[1] === 0x4D) {
            return { format: 'bmp', base64 };
        }

        return null;
    } catch (error) {
        return null;
    }
}

function dataURLToBlob(dataURL) {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

async function extractImagesFromPictGroups(rtfString, file, isEmbedding, abortedFiles) {
    let result = rtfString;
    const pictRegex = /{\\pict[^}]*}([a-fA-F0-9\s\r\n]+)}/g;
    let match;
    let imageIndex = 1;

    while ((match = pictRegex.exec(rtfString)) !== null) {
        if (handleAbort(file, abortedFiles, isEmbedding)) {
            return [];
        }
        let hexData = match[1].replace(/\s+/g, '');
        const imageInfo = detectImage(hexData);
        if (imageInfo) {
            try {
                const dataUrl = `data:image/${imageInfo.format};base64,${imageInfo.base64}`;
                let imgTag = dataUrl;

                try {
                    const blob = dataURLToBlob(dataUrl)
                    const imageSrc = await HtmlParsing.uploadImageFromFile(blob, file, imageIndex, imageInfo.format)
                    imgTag = `<img src="${imageSrc}" alt="${imageInfo.format} Image" style="max-width:100%;" />`;
                } catch (err) {
                } finally {
                    result = result.replace(match[0], imgTag);
                    imageIndex++;
                }
            } catch (err) {
                result = result.replace(match[0], '');
            }
        } else {
            result = result.replace(match[0], '');
        }
    }

    return result;
}

function rtfToHtmlBasic(rtf) {
    return rtf
        .replace(/\\par[d]?/g, '<br/>')
        .replace(/\\b (.+?)\\b0/g, '<b>$1</b>')
        .replace(/\\i (.+?)\\i0/g, '<i>$1</i>')
        .replace(/\\ul (.+?)\\ul0/g, '<u>$1</u>')
        .replace(/\\[a-z]+\d* ?/g, '')
        .replace(/[{}]/g, '')
        .trim();
}


function formatText(html) {
    const paragraphs = html.split(/<br\s*\/?>/)
        .map(p => p.trim())
        .filter(Boolean);

    return paragraphs.map(p => {
        if (p.includes('<img')) {
            return p;
        }
        return `<p>${escapeHtml(p)}</p>`;
    }).join('\n');
}

async function convertRtfToHtml(file, isEmbedding, abortedFiles,) {
    try {
        if (handleAbort(file, abortedFiles, isEmbedding)) {
            return [];
        }
        const rtfBuffer = await file.arrayBuffer();
        let rtfString = new TextDecoder('utf-8').decode(rtfBuffer);

        aiStore.sendAiProgressLoaderValue(file.name, 50)
        rtfString = await extractImagesFromPictGroups(rtfString, file, isEmbedding, abortedFiles);
        if (handleAbort(file, abortedFiles, isEmbedding)) {
            return [];
        }
        let html = rtfToHtmlBasic(rtfString);
        html = formatText(html);


        const chunks = HtmlParsing.splitHtmlIntoChunks(html);

        return chunks;
    } catch (error) {
        throw error;
    }
}

export { convertRtfToHtml };
